import React from 'react';
import classNames from 'classnames';
import SideNavItem from './SideNavItem';
import type { SideNavItemProps } from './SideNavItem';
import SideNavLink from './SideNavLink';
import { useSideNavContext } from './SideNavContext';

export interface SideNavProps {
  children: React.ReactElement<SideNavItemProps> | React.ReactElement<SideNavItemProps>[];
  className?: string;
}

const SideNav = ({ children, className }: SideNavProps): JSX.Element => {
  const { isNested } = useSideNavContext();

  return (
    <ul className={classNames({ 'usa-sidenav': !isNested, 'usa-sidenav__sublist': isNested }, className)}>
      {children}
    </ul>
  );
};

SideNav.Item = SideNavItem;
SideNav.Link = SideNavLink;

export default SideNav;
